module.exports = __webpack_public_path__ + "img/map_parking@2x.c9ef6af6.png";